import React from 'react'
import { useLocation } from 'react-router-dom'
import { DecreaseArrow, GrinIcon, IncreaseArrow } from '../Icons'

const NotFound: React.FC = (): React.ReactElement => {
  const location = useLocation()

  return (
    <div className="flex items-center justify-center min-h-screen bg-background-surface-01">
      <div className="text-center max-w-md">
        <div className="mb-8">
          <p className="text-sm font-medium mb-2 text-body-muted">
            Page Availability Test
          </p>
          <h2 className="flex items-center text-md font-semibold text-heading gap-1">Winning Variant: 404 Page not Found <GrinIcon /></h2>
          <p className="text-xs font-mono mt-2 text-body-muted break-all">
            Path: {location.pathname}
          </p>
        </div>

        <div className='border rounded-lg border-border-active flex flex-col p-2'>
          <div className='p-2 flex flex-row items-center'>
            <span className='font-medium text-heading text-sm basis-[60%] text-left'>You are lost:</span>
            <span className='font-medium text-heading text-md'>404.0%</span>
            <div className="flex items-center px-2 mx-2 py-2 rounded bg-background-success text-light text-xs font-bold max-h-6">
              100%
              <IncreaseArrow style={{ color: 'var(--color-text-light)' }} />
            </div>
          </div>

          <hr className="border-t border-border-default" />

          <div className='p-2 flex flex-row items-center'>
            <span className='font-medium text-heading text-sm basis-[60%] text-left'>Page Exists:</span>
            <span className='font-medium text-heading text-md'>0.0%</span>
            <div className="flex items-center px-2 mx-2 py-2 rounded bg-background-error text-light text-xs font-bold max-h-6">
              0%
              <DecreaseArrow style={{ color: 'var(--color-text-light)' }} />
            </div>
          </div>
        </div>

      </div>
    </div>
  )
}

export default NotFound
